import { combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import globalSessionReducer from "./globalSession/reducer";

const rootReducer = combineReducers({
  globalSession: globalSessionReducer,
});
export const store = createStore(rootReducer, composeWithDevTools());
export type StoreState = ReturnType<typeof rootReducer>;
